import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BellRing } from 'lucide-react';
import { SaButton, errMsg } from './ui';

// Backup new-lead alert channel (Gmail SMTP / webhook) — works while PLATFORM_EMAIL_MODE=log or Microsoft 365 is blocked.
export const LeadAlertCard = () => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const load = () => axios.get('/superadmin/lead-alerts/status').then((r) => setStatus(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const test = async () => {
    setBusy(true); setResult(null);
    try { const r = await axios.post('/superadmin/lead-alerts/test'); setResult(r.data); toast.success(r.data.email || r.data.webhook ? 'Test alert sent' : 'No channel delivered'); load(); }
    catch (e) { toast.error(errMsg(e, 'Could not send test alert')); } finally { setBusy(false); }
  };
  if (!status) return null;
  const ok = status.configured;
  return (
    <div data-testid="lr-lead-alert-card" style={{ background: '#141414', border: '1px solid #27272A', padding: 18, marginBottom: 18 }}>
      <div style={{ fontWeight: 800, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 }}><BellRing size={14} /> New-lead alerts (backup channel)</div>
      <div style={{ fontSize: 13, color: '#A1A1AA' }}>
        Status: <b data-testid="lr-lead-alert-status" style={{ color: ok ? '#22c55e' : '#ef4444' }}>{ok ? 'CONFIGURED' : 'NOT CONFIGURED'}</b>
        {' · '}Email: {status.email_channel_ready ? `${status.email_recipients.join(', ')} via ${status.smtp_account}` : (status.email_recipients.length ? 'recipients set but SMTP missing' : 'no recipients (LEAD_ALERT_EMAILS)')}
        {' · '}Webhook: {status.webhook_configured ? status.webhook_host : 'not set'}
        {' · '}Unseen leads: <b data-testid="lr-unseen-leads" style={{ color: '#fff' }}>{status.unseen}</b>
        {status.last_error && <span style={{ color: '#ef4444' }}> · last error: {status.last_error}</span>}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center' }}>
        <SaButton data-testid="lr-lead-alert-test" disabled={busy || !ok} onClick={test}><BellRing size={12} /> Send test alert</SaButton>
        <span style={{ fontSize: 12, color: '#71717A' }}>Sends a sample "new demo request" alert through every configured channel (uses the independent Gmail SMTP account, not Microsoft 365).</span>
      </div>
      {result && <div data-testid="lr-lead-alert-result" style={{ fontSize: 12, marginTop: 10, color: result.email || result.webhook ? '#22c55e' : '#ef4444' }}>
        email: {String(result.email)} · webhook: {String(result.webhook)}{result.status?.last_error ? ` · ${result.status.last_error}` : ''}
      </div>}
    </div>
  );
};
